const hoverTarget = [...document.querySelectorAll('.js-hover')];
const hoverChangeTarget = [...document.querySelectorAll('.js-hover-change')];
const mediaQueryList = window.matchMedia('(min-width: 769px)');

function mouseOver(array, imageElement) {
  array.forEach((e, index) => {
    e.addEventListener('mouseover', () => {
      imageElement[index].style.backgroundColor = '#333';
    });
  });
}

function mouseLeave(array, imageElement) {
  array.forEach((e, index) => {
    e.addEventListener('mouseleave', () => {
      imageElement[index].style.backgroundColor = '#fff';
    });
  });
}

const listener = (event) => {
  if (event.matches) {
    mouseOver(hoverTarget, hoverChangeTarget);
    mouseLeave(hoverTarget, hoverChangeTarget);
  }
};

mediaQueryList.addEventListener('change', listener);

listener(mediaQueryList);